<div class="object" *ngIf="object">
  <ng-container *ngIf="!newObject">
    <div class="object_preview" *ngIf="gallery" (click)="galleryModal = true">
      <img [src]="object.src" onerror="this.onerror=null; src=`./assets/images/no-image.png`;">
    </div>
    <div class="object_preview" *ngIf="!gallery" [routerLink]="isNew ? ['/main'] : ['/main', 'object', object.id, 'information']">
      <img class="needToSetOrientation" [src]="object.src" onerror="this.onerror=null; src=`./assets/images/no-image.png`;" >
    </div>
    <div class="object-name" [routerLink]="isNew ? ['/main'] : ['/main', 'object', object.id, 'information']">
      <div class="scrollable">
        <p class="name">{{ object.name }}</p>
      </div>
    </div>
    <div class="object_navigation" >
      <div class="object_navigation-item" [routerLink]="['/main', 'object', object.id, 'information']" routerLinkActive="active">
        <div class="object_navigation-item_icon jc-sa">
          <div class="fz-12 fz-11">Выполнено</div>
          <div class="obj-title">{{object.counter}}/29</div>
        </div>
        <div class="object_navigation-item_title">
          <div>
              Информация
          </div>
        </div>
      </div>
      <div class="object_navigation-item construction" [routerLink]="['/main', 'object', object.id, 'construction']"
        routerLinkActive="active" [ngClass]="getCompletePercent(object.completion_percent) === 100? 'green': ''">
        <div class="object_navigation-item_icon jc-sa">
          <div class="fz-12 fz-11">Завершено</div>
          <div class="obj-title" *ngIf="getCompletePercent(object.completion_percent) !== 0 && getCompletePercent(object.completion_percent) > 0.5">{{getCompletePercent(object.completion_percent)  | number:'1.0-0'}}<i>%</i></div>
          <div class="obj-title" *ngIf="getCompletePercent(object.completion_percent) === 0  || getCompletePercent(object.completion_percent) < 0 || getCompletePercent(object.completion_percent) < 0.5">-</div>
        </div>
        <div class="object_navigation-item_title"><div>
            Ход строительства
        </div></div>
      </div>
      <div class="object_navigation-item" [routerLink]="['/main', 'object', object.id, 'financing']" routerLinkActive="active" [ngClass]="financePercent === 100? 'green': ''">
        <div class="object_navigation-item_icon jc-sa">
            <div class="fz-12 fz-11">Освоено</div>
            <div class="obj-title" *ngIf="financePercent !== 0 && financePercent > 0.5"> {{financePercent | number:'1.0-0'}}<i>%</i></div>
            <div class="obj-title" *ngIf="financePercent === 0  || financePercent < 0 || financePercent < 0.5">-</div>
        </div>
        <div class="object_navigation-item_title">
          <div>Финансирование</div>
        </div>
      </div>
      <button class="object_navigation-item" [routerLink]="['/main', 'object', object.id, 'realization']" [ngClass]="object.realizationPer === 100? 'green': ''" [disabled] = "object.completion_percent < 100" routerLinkActive="active">
        <div class="object_navigation-item_icon jc-sa">
          <div class="fz-12 fz-11">Реализовано</div>
          <div class="obj-title" *ngIf="object.realizationPer !==  0 && object.realizationPer > 0.5">{{object.realizationPer | number:'1.0-0'}}<i>%</i></div>
          <div class="obj-title" *ngIf="object.realizationPer === 0  || object.realizationPer < 0 || object.realizationPer < 0.5 || object.realizationPer === null">-</div>
        </div>
        <div class="object_navigation-item_title">
          <div>
            Реализация
          </div>
        </div>
      </button>
      <button
        *ngIf="editMode"
        class="object_navigation-item" [routerLink]="['/main', 'object', object.id, 'materials']" routerLinkActive="active">
        <div class="object_navigation-item_title">
          <div>
            ПСД
          </div>
        </div>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="newObject">
    <div class="object_preview">
      <img [src]="">
    </div>
    <div class="object_name" [routerLink]="isNew ? ['/main'] : ['/main', 'object', object.id, 'information']">{{object.name}}</div>

    <div class="object_navigation">
      <div class="object_navigation-item" [routerLink]="['/main', 'object', object.id, 'information']" routerLinkActive="active">
        <div class="object_navigation-item_icon">
          <span class="icon-info"></span>
        </div>
        <div class="object_navigation-item_title">Информация</div>
      </div>
      <div class="object_navigation-item construction">
        <div class="object_navigation-item_icon">
          <span>{{getCompletePercent(object.completion_percent)}}<i>%</i></span>
        </div>
        <div class="object_navigation-item_title">Ход строительства</div>
      </div>
      <div class="object_navigation-item">
        <div class="object_navigation-item_icon">
          <span class="icon-tenge">₸</span>
        </div>
        <div class="object_navigation-item_title">Финансирование</div>
      </div>
      <div class="object_navigation-item">
        <div class="object_navigation-item_icon">
          <span>0</span>
        </div>
        <div class="object_navigation-item_title">Реализация</div>
      </div>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="galleryModal && galleryOpenable">
  <app-modal-window [title]="'Фото и видео'" [visible]="galleryModal" (close)="galleryModal = $event" [height]="600"
    [scrollbar]="true">
    <app-object-gallery></app-object-gallery>
  </app-modal-window>
</ng-container>
